import { BaseUserToken } from './baseUserToken';

/**
 * @class Default user token for anonymous users
 */
export class AnonymousUserToken<TUser extends object> extends BaseUserToken<TUser> {}
